import styled from '@emotion/styled'
import { Tabs } from '@mui/material';


export const TabsStyled = styled(Tabs)`
    background-color: ${({theme})=> theme.colors.section_color};
`;
